import {
  GAP_YEAR_STUDENT,
  INTERNATIONAL_COLLEGE_STUDENT_ID,
  INTERNATIONAL_GRADUATE_STUDENT_ID,
  INTERNATIONAL_HIGH_SCHOOL_STUDENT_ID,
  NOT_ENROLLED,
  US_COLLEGE_STUDENT_ID,
  US_GRADUATE_STUDENT_ID,
  US_HIGH_SCHOOL_STUDENT_ID,
  WORKING_PROFESSIONAL_ID,
} from "@/constants";

export const requiredLearnerInformationFields = (session: Record<string, any>, learnerTypeId: string): string[] => {
  const languages = ["languages"];
  const gpa = ["cumulative_gpa"];
  const expectedGraduationDate = ["expected_graduation_date"];
  const majors = ["majors"];
  const yearInSchool = ["year_in_school_at_time_of_api_program"];
  const disciplinarySanctions = ["disciplinary_sanctions"];
  const addresses = [
    "current_address_country_id",
    "current_address_city",
    "current_address_line_1",
    "permanent_address_country_id",
    "permanent_address_city",
    "permanent_address_line_1",
  ];
  const requiresApplication: boolean = session.requires_application;
  const isGpaRequired: boolean = session.is_gpa_required;
  switch (learnerTypeId) {
    case GAP_YEAR_STUDENT: {
      let fields: string[] = [...disciplinarySanctions, ...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case WORKING_PROFESSIONAL_ID: {
      let fields: string[] = [...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case US_COLLEGE_STUDENT_ID: {
      let fields: string[] = [
        ...yearInSchool,
        ...expectedGraduationDate,
        ...disciplinarySanctions,
        ...addresses,
        ...majors,
      ];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case US_HIGH_SCHOOL_STUDENT_ID: {
      let fields: string[] = [...yearInSchool, ...disciplinarySanctions, ...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case US_GRADUATE_STUDENT_ID: {
      let fields: string[] = [...disciplinarySanctions, ...addresses, ...expectedGraduationDate];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case INTERNATIONAL_HIGH_SCHOOL_STUDENT_ID: {
      let fields: string[] = [...yearInSchool, ...disciplinarySanctions, ...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case INTERNATIONAL_COLLEGE_STUDENT_ID: {
      let fields: string[] = [...yearInSchool, ...disciplinarySanctions, ...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case INTERNATIONAL_GRADUATE_STUDENT_ID: {
      let fields: string[] = [...disciplinarySanctions, ...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    case NOT_ENROLLED: {
      let fields: string[] = [...disciplinarySanctions, ...addresses];
      if (requiresApplication) {
        if (isGpaRequired) {
          fields = [...fields, ...gpa];
        }
        fields = [...fields, ...languages];
      }
      return fields;
    }
    default:
      return [] as string[];
  }
};
